module.exports = __webpack_public_path__ + "static/sc-924041bae5660c7121442b7f29801c17.png";